/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulas use only height and sex — not build or muscle.`)
};

const es_iw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las fórmulas solo usan la altura y el sexo, no la complexión ni el músculo.`)
};

const de_iw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Formeln berücksichtigen nur Körpergröße und Geschlecht — nicht Statur oder Muskulatur.`)
};

const nl_iw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De formules gebruiken alleen lengte en geslacht — niet lichaamsbouw of spiermassa.`)
};

const fr_iw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les formules n'utilisent que la taille et le sexe — pas la carrure ni le muscle.`)
};

const it_iw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le formule usano solo altezza e sesso — non corporatura o massa muscolare.`)
};

const pt_br2_iw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As fórmulas usam apenas altura e sexo — não porte físico nem músculo.`)
};

const pt_iw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As fórmulas usam apenas a altura e o sexo — não a constituição física nem o músculo.`)
};

const ja_iw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`計算式は身長と性別のみを使用し、体格や筋肉量は考慮しません。`)
};

const zh_iw_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这些公式只考虑身高和性别——不考虑体型或肌肉量。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iw_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iw_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iw_ex3", locale)
	if (locale === "en") return en_iw_ex3(inputs)
	if (locale === "es") return es_iw_ex3(inputs)
	if (locale === "de") return de_iw_ex3(inputs)
	if (locale === "nl") return nl_iw_ex3(inputs)
	if (locale === "fr") return fr_iw_ex3(inputs)
	if (locale === "it") return it_iw_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_iw_ex3(inputs)
	if (locale === "pt") return pt_iw_ex3(inputs)
	if (locale === "ja") return ja_iw_ex3(inputs)
	return zh_iw_ex3(inputs)
};